export default __webpack_public_path__ + "static/media/qr_code.77167022.svg";